import { useI18n } from "../lib/i18n";

const ACT = { received: "received", edited: "edited", dispatched: "dispatchedAct", parts_delivered: "partsDeliveredAct", returned: "returnedAct", parts_returned: "partsReturnedAct" };
const DOT = { received: "bg-emerald-500", edited: "bg-amber-500", dispatched: "bg-rose-500", parts_delivered: "bg-sky-500", returned: "bg-orange-600", parts_returned: "bg-orange-400" };

export const History = ({ items }) => {
  const { t, fmt } = useI18n();
  return (
    <ol className="relative border-s-2 border-slate-200 ms-2 space-y-4" data-testid="car-history">
      {items.map((h, i) => (
        <li key={i} className="ms-4" data-testid={`history-item-${i}`}>
          <span className={`absolute -start-[7px] mt-1.5 w-3 h-3 rounded-full ${DOT[h.action]}`} />
          <div className="text-sm font-bold">{t(ACT[h.action])}</div>
          <div className="text-xs text-slate-500">{fmt(h.date)} · {t("by")} {h.by_name}</div>
          {h.note && <div className="text-xs text-slate-600 mt-0.5" dir="auto">{h.note}</div>}
        </li>
      ))}
    </ol>
  );
};
